import React from 'react';
import Login from '../pages/login/Login';

const Footer: React.FC = () => {
    return (
        <>
            <Login />
            <footer id="footer">
                <div className="clear">
                    <div className="leftBox">
                        <div className="link">
                            <a href="http://www.kyobo.co.kr/">교보생명</a>
                            <a href="http://www.aimmed.co.kr/">에임메드</a>
                            <a href="#" style={{fontWeight: "10px"}}>개인정보처리방침</a>
                        </div>
                        <div className="copyright f11 mt10 lh20">
                            Copyright © 2008 KYOBO All Rights Reserved.<br />
                            본 서비스는 교보생명보험주식회사와 제휴한 (주)에임메드에서 제공합니다.
                        </div>
                    </div>
                    <div className="rightBox">
                        <a href="#">
                            <span className="pc"><img src="/images/common/footer_img.png" alt="교보생명"></img></span>
                            <span className="mobile"><img src="/images/common/footer_img_m.png" alt="교보생명" style={{width: "75.5px", height: "24px"}}></img></span>
                        </a>
                        <a href="#">
                            <span className="pc"><img src="/images/common/footer_img2.png" alt="AIMMED"></img></span>
                            <span className="mobile"><img src="/images/common/footer_img2_m.png" alt="AIMMED" style={{width:"82px", height:"27.5px"}}></img></span>
                        </a>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;